<template>
  <div class="xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">播放日志-{{dateType}}</div>
          <div
            class="xc-modal-close"
            @click="layerClose"
          ></div>
        </div>
        <div class="xc-modal-body">
          <div class="xc-form-inline">

            <template v-if="dateType == '每日'">
              <xc-form-item
                label="时间"
                required
                :error="errors.first('dayTime','value')"
                class="xc-form-item-fixed"
              >
                <flat-pickr
                  v-model="mix_query.dayTime"
                  class="xc-input"
                  :config="config"
                  placeholder="请选择时间"
                  name="dayTime"
                  v-validate="'required'"
                  data-vv-as="时间"
                ></flat-pickr>
              </xc-form-item>
            </template>

            <template v-if="dateType == '每月'">
              <xc-form-item
                label="时间"
                required
                :error="errors.first('monthTime','value')"
                class="xc-form-item-fixed"
              >
                <flat-pickr
                  v-model="mix_query.monthTime"
                  class="xc-input"
                  :config="config"
                  placeholder="请选择时间"
                  name="monthTime"
                  v-validate="'required'"
                  data-vv-as="时间"
                ></flat-pickr>
              </xc-form-item>
            </template>

            <template v-if="dateType == '时间段'">
              <xc-form-item
                label="时间"
                required
                :error="errors.first('dayTime','value')"
                class="xc-form-item-fixed"
              >
                <flat-pickr
                  v-model="mix_query.dayStartTime"
                  class="xc-input"
                  :config="config"
                  placeholder="请选择时间"
                  name="dayTime"
                  v-validate="'required'"
                  data-vv-as="时间"
                ></flat-pickr>
                <span>至</span>
                <flat-pickr
                  v-model="mix_query.dayEndTime"
                  class="xc-input"
                  :config="config"
                  placeholder="请选择时间"
                  name="dayTime"
                  v-validate="'required'"
                  data-vv-as="时间"
                ></flat-pickr>
              </xc-form-item>
            </template>

            <div class="xc-form-inline">
              <div class="xc-btn-group">
                <button
                  type="submit"
                  class="xc-btn xc-btn-primary"
                  @click.prevent="mix_search"
                >查询</button>
                <!-- <button
                  type="submit"
                  class="xc-btn xc-btn-primary"
                  @click="exportTable"
                  v-if="dateType == '时间段'"
                >导出</button> -->
              </div>
            </div>
          </div>

          <!-- 带滚动条的表格 -->
          <div class="xc-row-scroll">
            <table class="xc-table">
              <thead>
                <th>终端组</th>
                <th>设备序列号</th>
                <th>设备MAC</th>
                <th>统计周期</th>
                <th>素材</th>
                <th>总次数</th>
              </thead>
              <tbody>
                <template v-if="list && list.length">
                  <tr
                    v-for="(item,key) in list"
                    :key="key"
                  >
                    <td>{{item.groupName}}</td>
                    <td>{{item.deviceSerialNum}}</td>
                    <td>{{item.deviceMac}}</td>
                    <td>{{item.playDate}}</td>
                    <td>{{item.fileName}}</td>
                    <td>{{item.playNum}}</td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td
                      colspan="9"
                      class="xc-s-tac"
                    >暂无数据</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="xc-modal-footer">
          <div class="xc-btn-group">
            <div
              class="xc-btn xc-btn-default"
              @click="layerClose"
            >关闭</div>
          </div>

          <xc-pagination
            @change="mix_pageChange"
            :page="mix_page"
            :total="mix_total"
            :size="mix_pageSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../xc-ui/mixins/list";
import reportFormApi from "../api/report-forms";

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

// 日期控件
import "@/libs/flatpickr";
import { constants } from "crypto";

export default {
  name: "deviceStateDatail",
  data() {
    return {
      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "",

      dateType: this.$route.query.dateType,

      deviceCode: this.$route.query.deviceCode,

      // 日期选择
      time: "",
      // https://flatpickr.js.org/options/
      config: {
        // 时间格式
        // dateFormat: "Y-m",
        // 否启用时间选择
        enableTime: false,
        // 选择器中是否可以选择秒
        enableSeconds: false,
        // 用户可以选择的最大日期
        maxDate: ""
      },

      list: [],
      // 默认查询参数
      mix_query: {
        dayTime: "",
        dayStartTime: "",
        dayEndTime: "",
        monthTime: ""
      },
      tag: true
    };
  },

  async created() {
    this.mix_query.deviceCode = this.$route.query.deviceCode;
  },

  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },

    // 导出报表
    exportTable() {
      if (this.mix_query.dayEndTime && this.mix_query.dayStartTime) {
        reportFormApi.reportLogTimeFrameExcel(this.mix_query).then(v => {
          
        });
      } else {
        this.$message.error("请选择时间");
      }
    },

    // 初始化数据
    async initData(v) {
      if (this.tag) {
        await this.getNowFormatDate();
      }

      this.tag = false;

      // 默认搜索的数据
      const search = {
        pageNum: this.mix_page,
        pageSize: this.mix_pageSize,
        ...this.mix_query
      };

      if (this.dateType == "每日") {
        reportFormApi.reportLogDay(search).then(v => {
          this.setData(v);
        });
      } else if (this.dateType == "每月") {
        reportFormApi.reportLogMonth(search).then(v => {
          this.setData(v);
        });
      } else if (this.dateType == "时间段") {
        reportFormApi.reportLogTimeFrame(search).then(v => {
          this.setData(v);
        });
      }
    },

    setData(v) {
      this.list = this.mix_format(v.data.list);
      this.mix_total = v.data.total;
      this.mix_page = v.data.pageNum;
      this.mix_pageSize = v.data.pageSize;
    },

    // 获取前一天日期
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var curMonth = year + seperator1 + month;
      var yestodayDate = year + seperator1 + month + seperator1 + strDate;
      // let firstSevenDay = year + seperator1 + month + seperator1 + strDate;
      this.mix_query.dayTime = yestodayDate;
      this.mix_query.dayStartTime = yestodayDate;
      this.mix_query.dayEndTime = yestodayDate;
      this.mix_query.monthTime = curMonth;
      this.config.maxDate = yestodayDate;
      if (this.$route.query.dateType == "每月") {
        this.config.dateFormat = "Y-m";
        // this.config.disable = true
      }
    }
  },
  mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.xc-modal-footer {
  display: flex;
  align-items: center;
}
.xc-form-item-fixed span {
  padding: 0 8px;
}
</style>
